export default {
	properties: [
		{
			text: 'Nombre',
			key: 'name',
			type: 'text',
			value: '',
			is_title: true,
		},
		{
			text: 'N° de documento',
			key: 'doc_number',
			type: 'text',
			value: '',
			show: true,
			use_to_check_if_is_repeat: true,
		},
		{
			text: 'Contraseña',
			key: 'visible_password',
			type: 'text',
			value: '',
		},
		{
			text: 'Permisos',
			key: 'permissions',
			store: 'permission',
			belongs_to_many: {
				with_checkbox: true,
			}
		},
	],
	singular_model_name_spanish: 'Empleado',
	plural_model_name_spanish: 'Empleados',
	create_model_name_spanish: 'Nuevo empleado',
	text_delete: 'el',
}